import { useContext } from "react";
import { ConfigurationContext } from "contexts";

/** Browser detection hook. Uses the detection library's browser detection process.
 *
 * @param {proc} onDone
 * @param {proc} onError
 * @returns
 */
export const useBrowserDetection = (onDone, onError) => {
  const config = useContext(ConfigurationContext);

  /** Run the browser detection.
   */
  const run = () => {
    // Configure the host.
    var subDomain = window.location.hostname
      .toLowerCase()
      .replace(".systemrequirementslab.com", "");
    if (
      subDomain !== "test.cyri" &&
      subDomain !== "prod.cyri" &&
      subDomain !== "www"
    ) {
      subDomain = "www";
    }

    // Set the detection settings.
    window.SRL.detection.init({
      loggingLevel: config.loggingLevel,
      host: subDomain, //window.location.hostname.toLowerCase().replace(".systemrequirementslab.com",""),
      //host: "test.cyri",
      protocol: "https",
      referrerId: config.referrerId,
      requirementSetId: config.requirementSetId,
      onProgress: null,
      onError: onError,
      onDone: onDone,
      computerId: config.computerId,
      systemId: config.systemId,
      scanPopups: config.detection.popupTest,
      scanWhatFix: config.detection.marriottWhatFix,
    });

    // Run the detection.
    window.SRL.detection
      .runScan({})
      .then(() => {})
      .catch((error) => {
        console.log("Caught error: " + error.message);
      });
  };

  return run;
};
